import { FC, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import { useCreateTrailerMutation } from '../../api/trailer';
import { TrailerForm } from '../../components/TrailerForm';
import { TrailerCreate } from '../../Trailer.entity';

type Props = {
  onRefresh: () => void;
};

const INITIAL_FORM: TrailerCreate = {
  number: '',
};

export const CreateTrailerModal: FC<Props> = ({ onRefresh }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<TrailerCreate>(INITIAL_FORM);

  const [createTrailer, { isLoading }] = useCreateTrailerMutation();

  const handleChange = (name: keyof TrailerCreate, value: TrailerCreate[keyof TrailerCreate]) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid) return;

    createTrailer(form).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Прицеп успешно создан', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Создание прицепа"
      visible
      isLoadingSubmit={isLoading}
      width={500}
      height="auto"
      textConfirm="Создать"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <TrailerForm form={form} onChange={handleChange} />
    </ModalForm>
  );
};

export default CreateTrailerModal;
